// extracted by mini-css-extract-plugin
module.exports = {"first-kv":"FirstKv_first-kv__2glSY"};